import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  width: '100%',
  position: 'fixed',
  bottom: theme.spacing(0),
  zIndex: '4',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  backgroundColor: theme.palette.secondary.dark,
  padding: theme.spacing(1, 3),
  borderTop: `1px solid ${theme.palette.divider[7]}`,
  backdropFilter: `blur(${theme.spacing(1)})`,
  gap: theme.spacing(1.25),
    [theme.breakpoints.down('md')]: {
      justifyContent: 'center',
    },
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
 '& .MFBtn':{
  minWidth: theme.spacing(18.75),
 },

}));

export { StyledBox };
